import { useEffect, useState } from 'react'
import { getQuiz } from '../api'
import fakeQuizData from '../utils/fakeQuizData'
import { FAKE_QUIZ_DATA_MODE } from '../configs'
import useReactPressContext from './useReactPressContext'

const useGetQuizData = (quizId: string | null): IQuiz | undefined => {
  const { wpapi } = useReactPressContext()
  const [quizData, setQuizData] = useState<any>(undefined)

  useEffect(() => {
    if (quizId !== null && wpapi !== undefined) {
      getQuiz(wpapi, quizId)
        .then((data: IQuiz) => {
          setQuizData(data)
        })
        .catch((error: unknown) => {
          console.error(error)
        })
    }
  }, [quizId, wpapi])

  if (FAKE_QUIZ_DATA_MODE) return fakeQuizData
  else return quizData
}

export default useGetQuizData
